import {
  Box,
  LinearProgress,
  Stack,
  Typography,
  linearProgressClasses,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 30,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.dark.light : "#fff",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.secondary.dark,
  },
}));

export function RemainingCredits({ displayDetail = false }) {
  const theme = useTheme();

  const { data, isLoading } = useSelector(
    (state) => state.dashboard.photograph
  );

  if (isLoading) {
    return null;
  }

  if (!data) {
    return null;
  }
  const percent = Math.min(
    Math.round((data.nb_imported_photos / data.total_limit) * 100),
    100
  );

  const remaining = data.total_limit - data.nb_imported_photos;

  return (
    <Stack direction="column" spacing={1}>
      <Stack direction="row" spacing={2}>
        <Typography
          variant="h6"
          sx={{
            color:
              theme.palette.mode === "dark"
                ? theme.palette.dark.light
                : theme.palette.primary[800],
          }}
        >
          <FormattedMessage id="profile.credit" />
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Typography variant="h5">
          <FormattedMessage
            id="general.prcent_value"
            values={{ value: Math.round(percent) }}
          />
        </Typography>
        {displayDetail && (
          <Typography variant="caption" color="inherit">
            <FormattedMessage
              id="profile.remaining_credits"
              values={{ count: remaining }}
            />
          </Typography>
        )}
      </Stack>
      {!displayDetail && (
        <Typography variant="caption" color="inherit">
          <FormattedMessage
            id="profile.remaining_credits_fraction"
            values={{
              nb_imported_photos: data.nb_imported_photos,
              total_limit: data.total_limit,
            }}
          />
        </Typography>
      )}

      <BorderLinearProgress
        variant="determinate"
        color="error"
        value={percent}
      />
    </Stack>
  );
}

RemainingCredits.propTypes = {
  displayDetail: PropTypes.bool,
};

export default RemainingCredits;
